import { IMG } from "@/lib/brand";
import { PageHero, Reveal, SectionEyebrow } from "@/components/Section";
import { HexWatermark } from "@/components/BrandMark";
import { useLang } from "@/lib/LanguageContext";

export default function About() {
  const { t } = useLang();
  const a = t.about;

  return (
    <div data-testid="about-page" className="bg-white">
      <PageHero
        testId="about-hero"
        eyebrow={a.hero_eyebrow}
        title={a.hero_title}
        intro={a.hero_intro}
        image={IMG.factory}
      />

      <section className="container-x py-24 sm:py-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <SectionEyebrow>{a.who_eyebrow}</SectionEyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight font-medium leading-[1.05]">
            {a.who_title_l1}
            <br /> {a.who_title_l2}
          </h2>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed">{a.who_intro}</p>
        </div>
        <div className="lg:col-span-6 img-zoom border border-border aspect-[4/3]">
          <img src={IMG.baltic} alt="Baltic" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="bg-secondary border-y border-border">
        <div className="container-x py-24 sm:py-32">
          <SectionEyebrow>{a.principles_eyebrow}</SectionEyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight font-medium leading-[1.05] max-w-3xl">
            {a.principles_title}
          </h2>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-border border border-border">
            {a.principles.map(([title, desc], i) => (
              <Reveal key={title} delay={i * 0.04}>
                <div className="bg-secondary p-8 sm:p-12 h-full" data-testid={`about-principle-${i}`}>
                  <div className="text-[11px] tracking-[0.22em] uppercase text-muted-foreground">
                    {a.principle_label} · 0{i + 1}
                  </div>
                  <h3 className="mt-5 font-display text-2xl sm:text-3xl font-medium tracking-tight">{title}</h3>
                  <p className="mt-4 text-muted-foreground leading-relaxed">{desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative bg-primary text-primary-foreground hex-pattern-light overflow-hidden">
        <HexWatermark
          opacity={0.08}
          size={760}
          strokeWidth={1.5}
          className="text-white -right-48 top-1/2 -translate-y-1/2"
        />
        <div className="relative container-x py-20 sm:py-28 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <SectionEyebrow light>{a.hq_eyebrow}</SectionEyebrow>
            <h2 className="mt-5 font-display text-white text-3xl sm:text-5xl tracking-tight font-medium leading-[1.05]">
              {a.hq_title_l1}
              <br />
              <span className="text-accent">{a.hq_title_l2}</span>
            </h2>
            <p className="mt-6 text-white/75 max-w-xl leading-relaxed">{a.hq_intro}</p>
          </div>
          <div className="lg:col-span-4 grid grid-cols-1 gap-4 text-white/80 text-sm">
            <div>BALTIVEX</div>
            <div>{a.hq_title_l1.replace(".", "")} · LV</div>
            <div>info@baltivex.com</div>
          </div>
        </div>
      </section>
    </div>
  );
}
